import { useTheme } from "arkh";
import { UserLoggedInNavigatorScreenProps } from "../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { WorkspaceTodoEditMain } from "./WorkspaceTodoEditMain/WorkspaceTodoEditMain";

import { WorkspaceTodoStack } from "./WorkspaceTodoEditStack";

function WorkspaceTodoEditNavigatorC(
  props: UserLoggedInNavigatorScreenProps<"WorkspaceTodoEdit">
) {
  const theme = useTheme();
  return (
    <WorkspaceTodoStack.Navigator
      screenOptions={{
        headerShown: true,
        headerStyle: {
          backgroundColor: theme["surface-background-light"],
        },
        cardStyle: {
          backgroundColor: theme["surface-background-light"],
        },
        headerShadowVisible: false,
        headerTitle: "",
        headerLeft: () => null,
      }}
    >
      <WorkspaceTodoStack.Screen
        name="WorkspaceTodoEditMain"
        component={WorkspaceTodoEditMain}
        initialParams={props.route.params}
      />
    </WorkspaceTodoStack.Navigator>
  );
}

export const WorkspaceTodoEditNavigator = withWebModal(
  WorkspaceTodoEditNavigatorC,
  true,
  {
    width: 1040,
    height: 740,
  }
);
